import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type CampaignItemSliceState = {
  didChange: boolean
}

const initialState: CampaignItemSliceState = {
  didChange: false,
}

export const campaignItemSlice = createSlice({
  name: 'campaignItem',
  initialState,
  reducers: {
    setDidChange: (state, action: PayloadAction<boolean>) => {
      state.didChange = action.payload
    },
    resetDidChange: (state) => {
      state.didChange = false
    },
  },
  selectors: {
    selectDidChange: (state) => state.didChange,
  },
})

const { actions, reducer, selectors } = campaignItemSlice

export const { setDidChange, resetDidChange } = actions
export const { selectDidChange } = selectors
export default reducer
